const urlRelatoriosLog = "/v1/RelatoriosLog";

const service = {
  methods: {
    $obterRelatorioLogPerfilTurmaEscrita(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogPerfilDaTurmaEscrita`, params);
    },
    $obterRelatorioLogCSVPerfilTurmaEscrita(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogPerfilDaTurmaEscritaCsv`, params);
    },
    $obterRelatorioLogPDFPerfilTurmaEscrita(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogPerfilDaTurmaEscritaPdf`, this.$getParamsObject(params));
    },
  }
};

export default service;
